import { AdFormat } from '@openx/types/gqlTypes';
import { exhaustiveCheck } from '@openx/utils/lib/exhaustiveCheck';
import type { TFunction } from 'i18next';
import { lazy } from 'yup';
import { type BannerCreativeFormData, getBannerCreativeSchema } from './bannerCreative';
import { getVideoCreativeSchema, type VideoCreativeFormData } from './videoCreative';

export type CreativeFormState = BannerCreativeFormData | VideoCreativeFormData;

export const getCreativeValidationSchema = (t: TFunction) => {
  return lazy((values: CreativeFormState) => {
    const adFormat = values.ad_format;

    switch (adFormat) {
      case AdFormat.Banner:
        return getBannerCreativeSchema(t);
      case AdFormat.Video:
        return getVideoCreativeSchema(t);
      default:
        return exhaustiveCheck(adFormat);
    }
  });
};
